module.exports = __webpack_public_path__ + "img/propStatus2.ad3ba240.png";